<div class="row" *ngIf="contactDetails">
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblRegNumber</label>
      <div class="lbl-info">
        <div class="flmid">
          <div class="licplate LPNo d-flex">
            <span class="icn-flag" [ngClass]="licensePlateClass"></span>
            {{contactDetails.licensePlate}}
          </div>
          <div class="imgWid">
            <ng-container>
              <img af-brand-logo [data-code]="appointmentDetails.brandCode" data-type="BRAND"
                class="{{appointmentDetails.brandName}}-icon common" [title]="contactDetails.brandCode"
                class="brandicon" alt="img" />
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblMake</label>
      <div class="lbl-info">
        {{contactDetails.companyMakeName}}
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblModel</label>
      <div class="lbl-info">
        {{contactDetails.modelName}}
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblEngineNumber</label>
      <div class="lbl-info">
        {{contactDetails.engineNumber}}
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label>Chassis No (VIN)</label>
      <div class="lbl-info">
        {{contactDetails.chassisNo}}

        <button class="btn btn-link ml-2" (click)="copyVINText()" placement="top" ngbTooltip="Copy VIN"
        aria-label="Center Align">
        <em class="fas fa-copy fa-lg"></em>
      </button>
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblMileage</label>
      <div class="lbl-info" *ngIf="contactDetails.kilometer else loadElseTemplate">
        {{contactDetails.kilometer}}&nbsp;KM
      </div>
      <ng-template #loadElseTemplate>
        NA
      </ng-template>
    </div>
  </div>
  
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblYear</label>
      <div class="lbl-info">
        {{contactDetails.year}}
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblColor</label>
      <div class="lbl-info">
       
       {{contactDetails.color}}
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label translate>lblVehicleType</label>
      <div class="lbl-info">
        {{contactDetails.vehicleTypeCode}}
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2">
    <div class="af-form-group">
      <label>Fuel Type</label>
      <div class="lbl-info">
        {{contactDetails.engineTypeCode}}
      </div>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2" *ngIf="contactDetails">
    <div class="af-form-group">
      <label translate>lblRegistrationDate</label>
      <div class="lbl-info">
        {{ contactDetails.registrationDate}}
      </div>
    </div>
  </div> 
  <div class="col-3 col-lg-3 col-xl-2" *ngIf="contactDetails">
    <div class="af-form-group">
      <label translate>lblLastRegistrationDate</label>
      <div class="lbl-info"  *ngIf="contactDetails.dmsRegistrationLastDate else loadElseDmsRegistrationLastDate">
        {{ contactDetails.dmsRegistrationLastDate | date : 'shortDate'}}
      </div>
      <ng-template #loadElseDmsRegistrationLastDate>
        -
      </ng-template>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2" *ngIf="contactDetails">
    <div class="af-form-group">
      <label translate>lblPrevInspectionDate</label>
      <div class="lbl-info" *ngIf="contactDetails.inspectionPrevDate else loadElseInspectionPrevDate">
        {{ contactDetails.inspectionPrevDate | date : 'shortDate'}}
      </div>
      <ng-template #loadElseInspectionPrevDate>
        -
      </ng-template>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2" *ngIf="contactDetails">
    <div class="af-form-group">
      <label translate>lblNextInspectionDate</label>
      <div class="lbl-info" *ngIf="contactDetails.inspectionNextDate else loadElseInspectionNextDate">
        {{ contactDetails.inspectionNextDate | date : 'shortDate'}}
      </div>
      <ng-template #loadElseInspectionNextDate>
        -
      </ng-template>
    </div>
  </div>
  <div class="col-3 col-lg-3 col-xl-2" *ngIf="contactDetails">
    <div class="af-form-group">
      <label translate>lblRemark</label>
      <div class="lbl-info" *ngIf="contactDetails.vehicleRemark else loadElseRemark">
        {{ contactDetails.vehicleRemark }}
      </div>
      <ng-template #loadElseRemark>
        -
      </ng-template>
    </div>
  </div>
</div>
